/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 验证电子邮件格式
 * @param email - 待验证的电子邮件地址
 * @returns 是否为有效的电子邮件格式
 */
export function isValidEmail(email: string): boolean {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

/**
 * 验证电话号码格式
 * @param phone - 待验证的电话号码
 * @returns 是否为有效的电话号码格式
 */
export function isValidPhoneNumber(phone: string): boolean {
  const phonePattern = /^\+44\d{10}$/; // 示例：英国电话号码格式
  return phonePattern.test(phone);
}

/**
 * 验证信用卡号格式
 * @param cardNo - 待验证的信用卡号
 * @returns 验证信息，错误提示
 *
 * */

export function validateCardNo(cardNo: string): string {
  console.log(cardNo, "Jing----cardNo");

  const cardPattern = /^(4|5)\d{12,18}$/;
  if (!cardNo) {
    return "empty";
  }
  if (!cardPattern.test(cardNo)) {
    return "invalid";
  }
  return "";
}
/**
 *
 * 验证信用卡有效期
 * @param expiryDate - 待验证的信用卡有效期
 * @param field - 有效期字段，例如 "month" 或 "year"
 * @returns 验证信息，错误提示
 * 如果field是"month"，函数会尝试将expiryDate.month和expiryDate.year转换为整数，并获取当前日期的年份和月份。
 * 然后，函数会比较信用卡的年份和月份与当前日期的年份和月份。如果信用卡的年份等于当前年份且信用卡的月份小于当前月份，则返回字符串"invalid"。
 *
 * */
export function validateExpiryDate(expiryDate: any, field: string): any {
  // 是否为空
  if (!(expiryDate["month"] && expiryDate["year"])) {
    return {
      expireDateMonth: expiryDate["month"] ? "" : "empty",
      expireDateYear: expiryDate["year"] ? "" : "empty",
    };
  }

  const month = parseInt(expiryDate.month);
  const year = parseInt(expiryDate.year);
  if (month && year) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    // 比较年份和月份
    if (year === currentYear && month < currentMonth) {
      return {
        expireDateMonth: "invalid",
        expireDateYear: "",
      };
    }
  }
  return {
    expireDateMonth: "",
    expireDateYear: "",
  };
}

/**
 * 验证信用卡安全码格式
 * @param cvv - 待验证的信用卡安全码
 * @returns 验证信息，错误提示
 * */
export function validateCVV(cvv: string): string {
  const cvvPattern = /^\d{3,4}$/;
  if (!cvv) {
    return "empty";
  }
  if (!cvvPattern.test(cvv)) {
    return "invalid";
  }
  return "";
}
